import api from './api';

export const recommendationService = {
  getAll: async () => api.get('/recommendations'),
  getInsights: async () => api.get('/advisor/insights'),
  getInsightsQuick: async () => api.get('/advisor/insights?quick=true'),
  chat: async (messages) => api.post('/advisor/chat', { messages }),
};
